exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-member[data-v-696e2f65] {\n  width: 200px;\n  height: 200px;\n}\n.img-radius[data-v-696e2f65] {\n  border-radius: 50%;\n}", ""]);

// exports
